import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { fetchDetails } from '../accounts';
import type { Dispatch, GetState } from '../../../../../model/State';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const { accountId } = getState().location.payload;

  dispatch(fetchDetails(accountId));
};
